<template>
    <div class="page-container">
        <div class="s-search-results__head">
            <h1 class="s-search-results__title s-strip__title">{{ appData.dictionary.resultsTitle }} “{{ term }}”</h1>
        </div>
        <div class="s-search-results__body">
            <Loader :class="[{ show: loading }, 'fixed']" />
            <SearchResultsList :results="results" :error-messages="errorMessages" :has-error="hasError" />
            <PagingBar
                v-if="!hasError && resultsCount > 0"
                :key="paginationUpdateKey"
                :results-count="resultsCount"
                :default-page="paging.page"
                :default-page-size="paging.pageSize"
                @paging-updated="pagingUpdated" />
        </div>
    </div>
</template>

<script>
import * as lib from 'Root/lib/lib.js'
import ajaxMixins from 'Root/vue/mixins/ajaxMixins'
import Loader from 'Root/vue/components/Loader.vue'
import SearchResultsList from 'Root/vue/components/SearchResults/SearchResultsList.vue'
import PagingBar from 'Root/vue/components/PagingBar.vue'

export default {
    components: {
        Loader,
        SearchResultsList,
        PagingBar,
    },

    mixins: [ajaxMixins],

    data() {
        return {
            initialized: false,
            loading: false,
            hasError: false,
            errorMessages: '',

            term: '',

            results: null,
            resultsCount: -1,

            paginationUpdateKey: 0,

            paging: {
                currentPage: 1,
                pageSize: this.appData.pageSizeOptions[0],
            },
        }
    },

    mounted() {
        this.iniSearchTerm()
        this.getResults()
        this.initialized = true
    },

    methods: {
        getResults() {
            const payload = {
                term: this.term,
                page: this.paging.currentPage,
                pageSize: this.paging.pageSize,
            }

            if (this.initialized) {
                lib.moveWindowToObj(jQuery(this.$el), -40)
            }

            this.ajax(this.appData.configuration.resultsEndpoint, payload, this.storeResults)
        },

        pagingUpdated(data) {
            this.paging.currentPage = data.page
            this.paging.pageSize = data.pageSize

            this.getResults()
        },

        iniSearchTerm() {
            const urlTerm = lib.getUrlParameter('term')

            if (urlTerm) {
                this.term = urlTerm
            }
        },

        storeResults(data) {
            this.resultsCount = data.resultsCount
            this.results = data.results
        },
    },
}
</script>
